// @flow
// TODO: consider migrating to SingleTypeSearch using everything TYPE.
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { MdSearch } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import * as selectors from '../../reducers';
import Typeahead from '../Typeahead/async';
import OmnisearchResult from '../OmnisearchResult';
import { generateFetcher } from './utils';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import {
  DRIVER_RESULT_TYPE,
  MONITOR_RESULT_TYPE,
  PARENT_RESULT_TYPE,
  STUDENT_RESULT_TYPE,
  GATE_RESULT_TYPE,
} from '../UserSearchResult/types';

import styles from './omnisearch.css';
import { Search } from '../CommonTexts';


export const OMNISEARCH_RESULT_TYPES = {
  route: 'route',
  monitor: MONITOR_RESULT_TYPE,
  busDriver: DRIVER_RESULT_TYPE,
  student: STUDENT_RESULT_TYPE,
  parent: PARENT_RESULT_TYPE,
  routeStop: 'route_stop',
  bus: 'bus',
  gate: GATE_RESULT_TYPE,
  everything: undefined,
};

type OmnisearchPropTypes = {
  fetchItems: string => Promise<Array<Object>>,
  onChange: Object => mixed
};

const test = {
  [OMNISEARCH_RESULT_TYPES.route]: 'short_name',
}



const RenderOmnisearchResult = (item) => {
  switch (item.result_type) {
    case OMNISEARCH_RESULT_TYPES.route:
      return item.short_name || '';
    
    case OMNISEARCH_RESULT_TYPES.parent:
      return `${item.first_name} ${item.last_name}` || '';

    case OMNISEARCH_RESULT_TYPES.student:
      return `${item.first_name} ${item.last_name}` || '';

    case OMNISEARCH_RESULT_TYPES.monitor:
      return `${item.first_name} ${item.last_name}` || '';

    case OMNISEARCH_RESULT_TYPES.bus:
      return item.name || '';

    case OMNISEARCH_RESULT_TYPES.gate:
      return item.name || '';
    default:
      return '';
  }
}


const Omnisearch = ({ fetchItems, onChange }: OmnisearchPropTypes) => (
  <Typeahead
    inputDebounce={300}
    renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
    className={styles.omnisearch}
    inputProps={{
      Icon: MdSearch,
      iconPosition: 'right',
      placeholder: Search(`${i18n.t('common.user', { count: 1 })}/${i18n.t('labels.route', { count: 1 })}`, 1),
      clearMargins: true,
    }}
    onChange={onChange}
    renderItem={
      (item, isHighlighted) => (
        <OmnisearchResult
          {...item}
          key={item.value}
          isSelected={isHighlighted}
          size="small"
        />
      )
    }
    clearAfterSelected={true}
    fetchItems={fetchItems}
    value={undefined}
    // renderSelectedItemValue={(item) => RenderOmnisearchResult(item)}
  />
);

export default connect(
  (state) => {
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const token = selectors.getToken(state);
    return {
      fetchItems: generateFetcher(
        OMNISEARCH_RESULT_TYPES.everything,
        schoolId,
        token,
      ),
    };
  },
  dispatch => ({
    onChange({ result_type, id }) {
      switch (result_type) {
        case OMNISEARCH_RESULT_TYPES.route: {
          dispatch(push(`/admin/map/route/${id}`));
          break;
        }
        case OMNISEARCH_RESULT_TYPES.monitor: {
          dispatch(push(`/admin/map/monitors/${id}`));
          break;
        }
        case OMNISEARCH_RESULT_TYPES.busDriver: {
          dispatch(push(`/admin/map/bus-driver/${id}`));
          break;
        }
        case OMNISEARCH_RESULT_TYPES.student: {
          dispatch(push(`/admin/map/students/${id}`));
          break;
        }
        case OMNISEARCH_RESULT_TYPES.bus: {
          dispatch(push(`/admin/map/bus/${id}`));
          break;
        }
        case OMNISEARCH_RESULT_TYPES.parent: {
          dispatch(push(`/admin/map/parents/${id}`));
          break;
        }
        default: { /* noop */ }
      }
    },
  }),
)(Omnisearch);



// WEBPACK FOOTER //
// ./src/scripts/components/Omnisearch/index.jsx